import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import getRequestParams from '@/helpers/getRequestParams'
import parseMinutes from '@/helpers/parseMinutes'

export const useTripsCarStore = defineStore('tripsCar', () => {
    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()

    const tripsCar          = ref({})
    const tripsCarProcess   = ref(false)
    const tripsCarMsg       = ref({})

    // Структура такая же, как у точек автомобиля
    const tripMonth = ref({
        energyConsumed: {
            value: null,
            value_text: null,
            unit: 'UNIT_KVH_100_KM'
        },
        mileage: {
            value: null,
            value_text: null,
            unit: 'UNIT_KM'
        },
        time: {
            value: null,
            value_text: null,
            unit: '',
        },
        acceleration: {
            value: null,
            value_text: null,
            unit: ''
        },
        braking: {
            value: null,
            value_text: null,
            unit: ''
        },
        fuelConsumption: {
            value: null,
            value_text: null,
            unit: ''
        }
    })
    const tripMonthProcess  = ref({})
    const tripMonthMsg      = ref({})

    async function readTripsCar(payload) {
        
        const token = tokenStore.access
        let result = {}

        if(token) { 
            tripsCarProcess.value = true
            let params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/trip${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                result = request
                tripsCarMsg.value = { success: true }
            } else {
                tripsCarMsg.value = { success: false, text: request.error }
            }

        } else {
            tripsCarMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        tripsCarProcess.value = false
        return result
    }

    async function readTripMonth(payload) {

        const token = tokenStore.access

        if (token) {

            tripMonthProcess.value = true
            let params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/trip/last_month_amount${params}`,
                method: 'GET',
                token
            })

            if (!request.error) {
                tripMonth.value.fuelConsumption.value = request.fuelConsumption
                tripMonth.value.mileage.value = request.mileage.toFixed(1)
                tripMonth.value.time.value = request.time
                tripMonth.value.time.value_text = parseMinutes(request.time)
                tripMonth.value.acceleration.value = request.acceleration
                tripMonth.value.braking.value = request.braking
                tripMonth.value.energyConsumed.value = request.energyConsumed
                tripMonthMsg.value = { success: true, text: '' }
            } else {
                tripMonthMsg.value = { success: false }
                tripMonthMsg.value.text = request.error
            }

            tripMonthProcess.value = false
        } else {
            tripMonthMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        return tripMonth.value
    }

    const setTripsCarMsg = data => tripsCarMsg.value = data

    return {
        tripsCar,
        tripsCarProcess,
        tripsCarMsg,
        tripMonth,
        tripMonthProcess,
        tripMonthMsg,
        readTripsCar,
        readTripMonth,
        setTripsCarMsg
    }
})
